import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationConfirmTokenLoginArgs,
  BackendUserAuthStatus,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ConfirmTokenLogin($authToken: String!, $loginDevice: String!) {
    confirmTokenLogin(authToken: $authToken, loginDevice: $loginDevice) {
      token
    }
  }
`;

type Variables = BackendMutationConfirmTokenLoginArgs;
type Result = BackendUserAuthStatus;

export const confirmTokenLogin = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
